import { jsx as _jsx } from "react/jsx-runtime";
// Component is currently in ALPHA mode.
// Read more: terra.vts.com/process/overview#alpha
import { forwardRef } from "react";
import { ListItemContent, wrapperClasses } from "../ListItemContent";
export const MenuItem = forwardRef(({ className = "", label, subtext, tags, avatar, iconName, onSelect, onClick, itemProps, }, ref) => {
    const handleClick = (e) => {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(e);
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (_jsx("li", Object.assign({ className: wrapperClasses({ className }), role: "menuitem", tabIndex: 0, ref: ref }, itemProps, { onClick: handleClick, onKeyDown: (event) => {
            if (["Enter", "Space"].includes(event.code)) {
                handleClick(event);
            }
        }, "aria-label": label, children: _jsx(ListItemContent, { label: label, subtext: subtext, tags: tags, avatar: avatar, iconName: iconName }) })));
});
//# sourceMappingURL=MenuItem.js.map